(function () {
  var mq = window.matchMedia('(min-width: 1024px)');

  function initAccordionExclusivity() {
    document.querySelectorAll('.yv-product__accordion').forEach(function (group) {
      group.addEventListener('toggle', function (e) {
        var target = e.target;
        if (!target || target.tagName !== 'DETAILS' || !target.open) return;
        group.querySelectorAll('.yv-product__accordion-row[open]').forEach(function (el) {
          if (el !== target) el.open = false;
        });
      }, true);
    });
  }

  function initMediaCarousel() {
    var mediaWrap = document.querySelector('[data-yv-product] .yv-product__media');
    if (!mediaWrap) return;
    var track = mediaWrap.querySelector('.yv-product__media-track');
    var dotsContainer = mediaWrap.querySelector('.yv-product__media-dots');
    if (!track) return;

    var dots = dotsContainer
      ? Array.prototype.slice.call(dotsContainer.querySelectorAll('.yv-product__media-dot'))
      : [];
    var items = Array.prototype.slice.call(track.querySelectorAll('.yv-product__media-item'));
    if (!items.length) return;

    var currentActive = 0;

    function syncHeight() {
      if (mq.matches) { track.style.height = ''; return; }
      var h = items[currentActive].getBoundingClientRect().height;
      if (h > 0) track.style.height = h + 'px';
    }

    var rafPending = false;
    function setActive() {
      rafPending = false;
      var trackRect = track.getBoundingClientRect();
      var trackCenter = trackRect.left + trackRect.width / 2;
      var nearest = 0;
      var nearestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var rect = items[i].getBoundingClientRect();
        var center = rect.left + rect.width / 2;
        var dist = Math.abs(center - trackCenter);
        if (dist < nearestDist) { nearestDist = dist; nearest = i; }
      }
      currentActive = nearest;
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('is-active', j === nearest);
      }
      syncHeight();
    }

    track.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = true;
      window.requestAnimationFrame(setActive);
    }, { passive: true });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var item = items[i];
        if (!item) return;
        track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      });
    });

    items.forEach(function (item) {
      var img = item.querySelector('img');
      if (!img) return;
      if (img.complete && img.naturalHeight > 0) return;
      img.addEventListener('load', syncHeight);
    });

    window.addEventListener('resize', syncHeight);
    if (mq.addEventListener) mq.addEventListener('change', syncHeight);

    setActive();
  }

  function init() {
    initAccordionExclusivity();
    initMediaCarousel();

    var layout = document.querySelector('[data-yv-product] .yv-product__layout');
    if (!layout) return;

    var media = layout.querySelector('.yv-product__media');
    var info = layout.querySelector('.yv-product__info');
    if (!media || !info) return;

    function remaining(el, down) {
      if (down) return el.scrollHeight - el.clientHeight - el.scrollTop;
      return el.scrollTop;
    }

    function normalizeDelta(e) {
      var dy = e.deltaY;
      if (e.deltaMode === 1) return dy * 16;
      if (e.deltaMode === 2) return dy * (e.target.clientHeight || window.innerHeight);
      return dy;
    }

    layout.addEventListener('wheel', function (e) {
      if (!mq.matches) return;

      var active = e.target.closest('.yv-product__media, .yv-product__info');
      if (!active) return;
      var other = active === media ? info : media;

      var delta = normalizeDelta(e);
      if (delta === 0) return;
      var down = delta > 0;

      if (remaining(active, down) > 1) return;

      if (remaining(other, down) > 1) {
        e.preventDefault();
        other.scrollTop += delta;
        return;
      }

      e.preventDefault();
      window.scrollBy(0, delta);
    }, { passive: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
